import { useState } from 'react';

export default function CompleteFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Do you need access to my backend or codebase?',
      answer: 'No. We evaluate your app from the outside using structured intelligence systems — no backend access required.'
    },
    {
      question: 'Do I get a downloadable report?',
      answer: 'Yes. Every tier includes a structured PDF report with insights, scores, and next steps.'
    },
    {
      question: 'Can I submit an idea, concept, or prototype?',
      answer: 'Yes. CrowdRounds works with MVPs, beta apps, no-code builds, prototypes, or launched apps.'
    },
    {
      question: 'Do you support no-code platforms like Bubble, Adalo, or Glide?',
      answer: 'Absolutely. Many of our clients use no-code tools — our intelligence systems work regardless of your platform.'
    },
    {
      question: 'How long does it take to receive my evaluation?',
      answer: 'Depending on your tier:\n• Tier 1: 24–48 hours\n• Tier 2: 2–3 days\n• Tier 3: 3–5 days\n• Tier 4: 5–7 days\n• Tier 5: 7–10 days'
    },
    {
      question: 'What if my app isn\'t live yet?',
      answer: 'No problem — we can evaluate prototypes, demos, Figma designs, or even idea-stage concepts.'
    },
    {
      question: 'Do you offer Buy Now, Pay Later?',
      answer: 'Yes. Flexible payment options are available at checkout.'
    },
    {
      question: 'What makes CrowdRounds different from beta testing?',
      answer: 'Beta testing gives opinions. CrowdRounds gives intelligence — structured analysis, scoring, benchmarking, and strategic recommendations.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl border-2 border-slate-200 overflow-hidden hover:border-teal-400 transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-slate-50 transition-colors"
              >
                <span className="text-lg font-bold text-slate-900 pr-4">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl text-teal-600 transition-transform duration-300`}></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5 pt-2">
                  <p className="text-slate-600 leading-relaxed whitespace-pre-line">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
